/*
  Route journal (click traces): automatic first days of a new campaign.
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Включено автоматически на первые дни кампании, до {date}. Чтобы оставить журнал включённым, включите его сами.",
};

const es = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Activado automáticamente durante los primeros días de la campaña, hasta el {date}. Actívalo tú para mantenerlo.",
};

const pt = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Ativado automaticamente nos primeiros dias da campanha, até {date}. Ative você mesmo para mantê-lo.",
};

const de = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Automatisch für die ersten Tage der Kampagne eingeschaltet, bis {date}. Schalte es selbst ein, um es zu behalten.",
};

const fr = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Activé automatiquement pour les premiers jours de la campagne, jusqu’au {date}. Activez-le vous-même pour le garder.",
};

const it = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Attivato automaticamente per i primi giorni della campagna, fino al {date}. Attivalo tu per mantenerlo.",
};

const pl = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Włączone automatycznie na pierwsze dni kampanii, do {date}. Włącz je sam, aby je zachować.",
};

const tr = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Kampanyanın ilk günleri için {date} tarihine kadar otomatik olarak açıldı. Açık kalması için kendiniz açın.",
};

const uk = {
  "Turned on automatically for the first days of the campaign, until {date}. Switch it on yourself to keep it.": "Увімкнено автоматично на перші дні кампанії, до {date}. Щоб журнал лишався увімкненим, увімкніть його самі.",
};

const LIVE_TRACE_AUTO = { ru, es, pt, de, fr, it, pl, tr, uk };
export default LIVE_TRACE_AUTO;
